<template>
  <div>
    <slot
      v-if="obj !== null"
      :obj="obj"
    >
    </slot>

    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../../http-common';
import notifier from '../../notifier';

import LoadingIndicator from '../LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'ObjBox',

  components: {
    LoadingIndicator,
  },

  props: {
    url: {
      type: String,
      required: true,
    },

    typeName: {
      type: String,
      default: null,
    },

    objId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      obj: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    message() {
      if(this.isLoadedNormal && this.obj === null) {
        return `${this.typeName} with id ${this.objId} not found.`;
      }
      return null;
    },
  },

  created() {
    this.loadObj();
  },

  methods: {
    loadObj() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      HTTP.get(this.url)
      .then(response => {
        this.obj = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
